import { render } from "./experienceAdd.vue?vue&type=template&id=353639d3&scoped=true"
import script from "./experienceAdd.vue?vue&type=script&lang=js"
export * from "./experienceAdd.vue?vue&type=script&lang=js"

import "./experienceAdd.vue?vue&type=style&index=0&id=353639d3&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353639d3"]])

export default __exports__